var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.loading)?_c('Loader'):_c('button',{staticClass:"btn btn--primary btn--large",attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v(" Connexion avec Google ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }